module.exports = __webpack_public_path__ + "media/images/team-1a1dd131b92c41e21af3458d238ab357.svg";